import isNil from './is-nil';
import isArraylike from './is-array-like';
export default function size(o) {
  if (isNil(o)) {
    return 0;
  }

  if (isArraylike(o)) {
    return o.length;
  }

  return Object.keys(o).length;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/size.js
// module id = 111
// module chunks = 0